import {
	alerts, CommunityActionTypes,
	entitiesReducer, exceptions, responseAlert, SendingFacilityActionTypes,
	sortedPaginate, ReportingActionTypes
} from 'gwx-voyager-components';
import reduceReducers from 'reduce-reducers';
import { combineReducers } from 'redux';
import { InvitationActionTypes } from '../Invitation/invitations.actions';
import { ClientInvitationActionTypes } from '../ClientInvitations/clientInvitations.actions';
import { SubscriptionActionTypes } from '../Subscription/subscriptions.actions';
import { ProfileActionTypes } from '../Profile/profile.actions';

const initialResult = { isFetching: false };
const initialResults = { isFetching: false, results: {}, ids: [] };

const entities = entitiesReducer({
	sendingFacilities: initialResults,
	providers: initialResults,
	sendingFacility: initialResult,
	provider: initialResult,
	events: initialResults,
	analyzenotificationevents: initialResults,
	opportunities: initialResults,
	optedoutevents: initialResults,
	adtEvents: initialResults,
	reportingAdtEvents: initialResults,
	HPDAddresses: initialResults,
	communities: initialResults,
	community: initialResult,
	communityIdsByEmail: initialResults,
	profile: initialResult,
	subscriptions: initialResults,
	invitation: initialResult,
	invitations: initialResults,
	clientInvitation: initialResult,
    clientInvitations: initialResults,
	preferences: initialResults,
	subscriptionhistory: initialResults,
	reportingNotificationEvents: initialResults,
	reportingNotificationStatuses: initialResults,
	reportingNotificationMime: initialResult,
	internalProviders: initialResults,
	untrustedDomains: initialResults,
	reportingAdt: initialResults,
	npiDetails: initialResult,
	hpdDetails: initialResult,
	validateSubscription: initialResults
});

const pagination = combineReducers({
	sendingFacilities: sortedPaginate(SendingFacilityActionTypes.GET_SENDING_FACILITIES),
	communities: sortedPaginate(CommunityActionTypes.GET_COMMUNITIES),
	invitations: sortedPaginate(InvitationActionTypes.GET_INVITATIONS),
	clientInvitations: sortedPaginate(ClientInvitationActionTypes.GET_CLIENT_INVITATIONS),
	reportingAdtEvents: sortedPaginate(ReportingActionTypes.GET_ADT_EVENTS),
	reportingNotificationEvents: sortedPaginate(ReportingActionTypes.GET_NOTIFICATION_EVENTS),
	internalProviders: sortedPaginate(SendingFacilityActionTypes.GET_INTERNAL_PROVIDERS),
	untrustedDomains: sortedPaginate(SendingFacilityActionTypes.GET_INTERNAL_PROVIDERS),
	subscriptions:sortedPaginate(SubscriptionActionTypes.GET_SUBSCRIPTIONS),
});

const alert = reduceReducers(
	alerts,
	responseAlert({
		types: SubscriptionActionTypes.SUBSCRIPTION_DELETE,
		successMessage: 'Subscription successfully deleted.'
	}), responseAlert({
		types: SubscriptionActionTypes.SUBSCRIPTION_OPT_IN,
		successMessage: 'The provider has been successfully subscribed.'
	}), responseAlert({
		types: SubscriptionActionTypes.SUBSCRIPTION_OPT_OUT,
		successMessage: 'The provider has been successfully unsubscribed.'
	}), responseAlert({
		types: InvitationActionTypes.ACCEPT_INVITATION,
		successMessage: 'Invitation successfully accepted.'
	}), responseAlert({
		types: InvitationActionTypes.DECLINE_INVITATION,
		successMessage: 'Invitation successfully declined.'
	}), responseAlert({
		types: ClientInvitationActionTypes.REVOKE_CLIENT_INVITATION,
		successMessage: 'Client invitation was successfully revoked.'
	}), responseAlert({
		types: ClientInvitationActionTypes.SEND_CLIENT_INVITATION,
		successMessage: 'Client invitation was successfully sent.'
	}), responseAlert({
		types: SendingFacilityActionTypes.UPDATE_SENDING_FACILITY,
		successMessage: 'Sending Facility was successfully updated.'
	}), responseAlert({
		types: ProfileActionTypes.UPDATE_PROFILE,
		successMessage: 'Profile was successfully updated.'
	}), responseAlert({
		types: ProfileActionTypes.DELETE_PROFILE_ATTRIBUTE,
		successMessage: 'Email was successfully removed.'
	}), responseAlert({
		types: ProfileActionTypes.RESEND_PROFILE_EMAIL_CONFIRMATION,
		successMessage: 'Email confirmation successfully sent.'
	})
);

const reportData = (state = {
	startIndex: 0,
	endIndex: 0
}, action) => {
	switch (action.type) {
		case 'ADT_EVENTS_SUCCESS':
			return {
				startIndex: action.response.result.content.length - 7,
				endIndex: action.response.result.content.length - 1
			};
		case 'UPDATE_BRUSH_INDICES':
			return {
				startIndex: action.indices.startIndex,
				endIndex: action.indices.endIndex
			};
		default:
			return state;
	}
};

const opportunityCount = (state = 0, action) => {
	switch (action.type) {
		case 'RECEIVE_OPPORTUNITY_COUNT':
			return action.count;
		default:
			return state;
	}
};

const rootReducer = combineReducers({
	pagination,
	alert,
	exceptions,
	entities,
	reportData,
	opportunityCount
});

export default rootReducer;
